import script from "./Input.vue?vue&type=script&lang=ts&setup=true"
export * from "./Input.vue?vue&type=script&lang=ts&setup=true"

import "./Input.vue?vue&type=style&index=0&id=084860b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-084860b1"]])

export default __exports__